module.exports = __webpack_public_path__ + "img/icons_7.ba710cf4.png";